import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { enableLogging } from 'mobx-logger';
import { ConfigProvider, theme } from 'antd';
import './mobx-config';

import ErrorBoundary from './bugsnag';
import App from './app';
import i18n from './i18n';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ErrorBoundary>
    <I18nextProvider i18n={i18n}>
      <ConfigProvider theme={{ algorithm: theme.defaultAlgorithm }}>
        <App />
      </ConfigProvider>
    </I18nextProvider>
  </ErrorBoundary>
);

process.env.NODE_ENV === 'development' && enableLogging();
